import angular from 'angular';
import template from './template.html';
import './style.scss';

export class RecruiterCandidatesPage {
    /* @ngInject */
    constructor($scope, $state, PublicProfileLinkGenerator, buildCSVService, TalentForEmployerService) {
        this.$scope = $scope;
        this.$state = $state;
        this.PublicProfileLinkGenerator = PublicProfileLinkGenerator;
        this.buildCSVService = buildCSVService;
        this.TalentForEmployerService = TalentForEmployerService;
        this.csvHeaders = buildCSVService.getCsvHeaders();
    }

    $onChanges() {
        this.$scope.searchCtrl = this.searchCtrl;
    }

    async createExcelFile() {
        const candidates = this.searchCtrl.getFilteredList();
        const talentIds = (candidates || []).map(({ talentID }) => talentID);
        const { result: profileForSubmissionMap } = await this.TalentForEmployerService.isTalentForEmployerExist({
            talentIds,
        });
        const processedCandidates = (candidates || []).map(candidate => {
            const isProfileForSubmission = profileForSubmissionMap[candidate.talentID];
            const talentUrl = this.PublicProfileLinkGenerator.generateLink(candidate, {
                isProfileForSubmission,
                isNamedProfile: true,
            });

            return {
                ...candidate,
                candidateData: {
                    ...candidate.candidateData,
                    talentUrl,
                },
            };
        });

        return this.buildCSVService.createCsvFile({
            resultList: processedCandidates,
        });
    }

    onCandidateClick(candidate) {
        this.$state.go('recruiter.candidatesJob', {
            talentID : candidate.talentID
        });
    }
}

export const RecruiterCandidatesPageConfiguration = {
    template,
    controller: RecruiterCandidatesPage,
    require: {
        searchCtrl: '^searchComponent'
    },
    controllerAs: 'recruiterCandidatesPageCtrl'
};

angular
    .module('TALENYA-FE')
    .component('recruiterCandidatesPage', RecruiterCandidatesPageConfiguration);
